import { useEffect, useRef } from "react";
import useState from "react-usestateref";
import NewFooter from "./landing/NewFooter";
import TELEGRAM from "../image/newLanding/landing-telegram.webp";
import CONTACTIMG from "../image/newLanding/contact-temple.svg";
import CONTACTIMGTWO from "../image/newLanding/contact-img.svg";
import PhoneInput from "react-phone-input-2";
import WHATSAPP from "../image/newLanding/landing-whatsapp.webp";
import MAIL from "../image/newLanding/landing-mail.webp";
import PHONE from "../image/newLanding/landing-phone.webp";
import ARROW from "../image/newLanding/arrow.webp";

import httpService from "../config/httpCall";
import { toastAlert } from "../config/toastAlert";
import { sendcontactpageContacts } from "../config/apiCall";
import { sendUnsubmitUserContacts } from "../config/apiCall";
import "./landing/Landing.css";

const ServiceFooter = () => {
  const [isReach, setIsReach] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [selectedPlatform2, setSelectedPlatform2] = useState("whatsApp");
  const [scrollY, setScrollY] = useState(0);
  const [isFooter, setIsFooter] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [colorChanged, setColorChanged] = useState(false);
  const [activeError, setActiveError] = useState(null);

  const NewFormfooterValue2 = {
    newformfootermediumValue: "",
    newformfootermedium: "whatsApp",
    newformfootermessage: "",
    newformfootermobile: "",
    newformfooteruserName: "",
    newformfootermobilecode: "",
  };

  const [newValue2, setnewValue2] = useState(NewFormfooterValue2);

  const handleReachClick = () => {
    setIsReach((prevReach) => !prevReach);
  };

  const NewFormValue = {
    newformmediumValue: "",
    newformmedium: "whatsApp",
    newformmessage: "",
    newformmobile: "",
    newformuserName: "",
    newformmobilecode: "",
  };

  const [newValue, setnewValue, newValueref] = useState(NewFormValue);

  const { newformuserName, newformmessage } = newValue;

  const [
    newformmediumValueErr,
    setnewformmediumValueErr,
    newformmediumValueErrref,
  ] = useState(false);

  const [newformmediumErr, setnewformmediumErr] = useState(false);
  const [newformmessageErr, setnewformmessageErr, newformmessageErrref] =
    useState(false);
  const [newformmobileErr, setnewformmobileErr, newformmobileErrref] =
    useState(false);
  const [newformuserNameErr, setnewformuserNameErr, newformuserNameErrref] =
    useState(false);
  const [newformmobilecodeErr, setnewformmobilecodeErr] = useState(false);
  const [validationErr, setvalidationErr, validationErrref] = useState("");
  const [platformInput, setPlatformInput, platformInputref] = useState("");

  const [NewFormNMobileCode, setNewFormNMobileCode] = useState();
  const [NewFormMobileValue, setNewFormMobileValue] = useState();
  const [NewFormcountry, setNewFormcountry] = useState();
  const hasSentData = useRef(false);

  useEffect(() => {
    const sendDataOnce = () => {
      if (!hasSentData.current) {
        sendDataToBackend();
        hasSentData.current = true;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sendDataOnce();
      }
    };

    const handleBeforeUnload = (event) => {
      sendDataOnce();
      event.preventDefault();
      event.returnValue = "";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [newValue, selectedPlatform2, platformInput, NewFormMobileValue]);

  const sendDataToBackend = async () => {
    try {
      const {
        newformuserName,
        newformmobilecode,
        newformmobile,
        newformmessage,
      } = newValueref.current;

      const userCountry = newValueref.current.NewFormcountry;
      const mediumDetail = platformInputref.current;
      // console.log("Data sent to backend starting *.*.*");

      if (
        newformuserName ||
        userCountry ||
        newformmobilecode ||
        newformmobile ||
        mediumDetail ||
        newformmessage
      ) {
        // console.log("Data sent to backend starting enters.....");
        const obj = {
          userName: newValueref.current.newformuserName,
          userCountry: newValueref.current.NewFormcountry,
          userCountryCode: newValueref.current.newformmobilecode,
          userMobilrNum: newValueref.current.newformmobile,
          contactMedium: selectedPlatform2,
          mediumDetail: platformInputref.current,
          userMessage: newValueref.current.newformmessage,
        };
        // console.log("Data sent to backend", obj);
        var messageSent = await sendUnsubmitUserContacts(obj);
        // console.log("messageSent---->>", messageSent);
      }
    } catch (error) {
      // console.error("Error sending data:", error);
    }
  };

  // const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
  //   setNewFormMobileValue(value);
  //   setNewFormNMobileCode(countryObj.dialCode);
  //   setNewFormcountry(countryObj.name);
  //   newValueref.current["newformmobilecode"] = countryObj.dialCode;
  //   newValueref.current["newformmobile"] = value;
  //   newValueref.current["NewFormcountry"] = countryObj.name;
  //   setSelectedPlatform2("whatsApp");
  //   setPlatformInput("");
  //   validate(newValueref.current);
  // };

  const handleNewFormMobile = (value, countryObj, e, formattedValue) => {
    setNewFormMobileValue(value);
    setNewFormNMobileCode(countryObj.dialCode);
    setNewFormcountry(countryObj.name);
    newValueref.current["newformmobilecode"] = countryObj.dialCode;
    newValueref.current["newformmobile"] = value;
    newValueref.current["NewFormcountry"] = countryObj.name;
    setSelectedPlatform2("whatsApp");
    setPlatformInput("");
    // validate(newValueref.current);
    validateNewFormMobile(value, countryObj.dialCode);
    console.log(newValueref.current);
  };

  const validateNewFormMobile = (mobileValue, dialCode) => {
    let error = {};
    const countryCodeLength = dialCode.length;
    const actualMobileLength = mobileValue.length - countryCodeLength;

    if (mobileValue.trim() === "") {
      setnewformmobileErr(true);
      error.newformmobile = "Mobile Number is a required field";
    } else if (actualMobileLength < 7) {
      setnewformmobileErr(true);
      error.newformmobile =
        "Invalid number, must be at least 7 digits excluding country code";
    } else {
      setnewformmobileErr(false);
    }

    setvalidationErr(error);
  };

  // const validate = async (formData) => {
  //   try {
  //     var error = {};
  //     const countryCodeLength = formData.newformmobilecode
  //       ? formData.newformmobilecode.length
  //       : "";
  //     const actualMobileLength = countryCodeLength
  //       ? formData.newformmobile.length - countryCodeLength
  //       : "";
  //     // const countryCodeLength = formData.newformmobilecode.length;
  //     // const actualMobileLength =
  //     //   formData.newformmobile.length - countryCodeLength;

  //     if (formData.newformuserName.trim() === "") {
  //       setnewformuserNameErr(true);
  //       error.newformuserName = "Must enter the field";
  //       setvalidationErr(error);
  //       return;
  //     } else if (formData.newformuserName.length < 3) {
  //       setnewformuserNameErr(true);
  //       error.newformuserName = "Invalid username, Must be 3-50 characters";
  //       setvalidationErr(error);
  //       return;
  //     } else {
  //       setnewformuserNameErr(false);
  //     }

  //     if (formData.newformmobile.trim() === "") {
  //       setnewformmobileErr(true);
  //       error.newformmobile = "Must enter the field";
  //       setvalidationErr(error);
  //       return;
  //     } else if (actualMobileLength < 7) {
  //       setnewformmobileErr(true);
  //       error.newformmobile =
  //         "Invalid number, Must be at least 7 digits excluding country code";
  //       setvalidationErr(error);
  //       return;
  //     } else {
  //       setnewformmobileErr(false);
  //     }
  //     if (
  //       (selectedPlatform2 === "email" && platformInputref.current === "") ||
  //       platformInputref.current.length == 0
  //     ) {
  //       setnewformmediumValueErr(true);
  //       error.newformmediumValue = "Must enter the field";
  //       setvalidationErr(error);
  //       return;
  //     } else if (
  //       selectedPlatform2 === "email" &&
  //       !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
  //         platformInputref.current
  //       )
  //     ) {
  //       setnewformmediumValueErr(true);
  //       error.newformmediumValue = "Invalid email format";
  //       setvalidationErr(error);
  //       return;
  //     } else if (
  //       ["whatsApp", "skype", "telegram"].includes(selectedPlatform2)
  //     ) {
  //       if (platformInputref.current.trim() === "") {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = "Must enter the field";
  //         setvalidationErr(error);
  //         return;
  //       } else if (
  //         selectedPlatform2 === "whatsApp" &&
  //         platformInputref.current.length < 7
  //       ) {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
  //         setvalidationErr(error);
  //         return;
  //       } else if (
  //         selectedPlatform2 === "skype" &&
  //         platformInputref.current.length < 5
  //       ) {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = ` Skype ID / Number must be at least 5 characters`;
  //         setvalidationErr(error);
  //         return;
  //       } else if (platformInputref.current.length < 5) {
  //         setnewformmediumValueErr(true);
  //         error.newformmediumValue = ` Telegram ID / Number must be at least 5 characters`;
  //         setvalidationErr(error);
  //         return;
  //       } else {
  //         setnewformmediumValueErr(false);
  //       }
  //     } else {
  //       setnewformmediumValueErr(false);
  //     }

  //     if (formData.newformmessage.trim() === "") {
  //       setnewformmessageErr(true);
  //       error.newformmessage = "Must enter the field";
  //       setvalidationErr(error);
  //     } else if (formData.newformmessage.length < 3) {
  //       setnewformmessageErr(true);
  //       error.newformmessage = "Message must contain at least 3 characters";
  //       setvalidationErr(error);
  //     } else if (formData.newformmessage.length > 250) {
  //       setnewformmessageErr(true);
  //       error.newformmessage = "Message can't exceed 250 characters";
  //       setvalidationErr(error);
  //     } else {
  //       setnewformmessageErr(false);
  //     }

  //     setvalidationErr(error);
  //   } catch (error) {
  //     // console.error(error);
  //   }
  // };

  const validate = async (formData) => {
    try {
      var error = {};
      console.log(formData.newformmobilecode);
      console.log(
        formData.newformmobilecode.length,
        formData.newformmobile.trim()
      );

      const countryCodeLength = formData.newformmobilecode.length;

      const actualMobileLength =
        formData.newformmobile.length - countryCodeLength;

      if (formData.newformuserName.trim() === "") {
        setnewformuserNameErr(true);
        error.newformuserName = "Name is a required field";
        setvalidationErr(error);
      } else if (formData.newformuserName.length < 3) {
        setnewformuserNameErr(true);

        error.newformuserName = "Invalid username, Must be 3-50 characters";
        setvalidationErr(error);
      } else {
        setnewformuserNameErr(false);
      }

      if (formData.newformmobile.trim() === "") {
        // setnewformuserNameErr(false);
        setnewformmobileErr(true);
        error.newformmobile = "Mobile Number is a required field";
        setvalidationErr(error);
      } else if (actualMobileLength < 7) {
        // setnewformuserNameErr(false);
        setnewformmobileErr(true);
        error.newformmobile =
          "Invalid number, Must be at least 7 digits excluding country code";
        setvalidationErr(error);
      } else {
        setnewformmobileErr(false);
      }

      if (
        (selectedPlatform2 === "email" && platformInputref.current === "") ||
        platformInputref.current.length == 0
      ) {
        // setnewformmobileErr(false);
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Contact Medium is a required field";
        setvalidationErr(error);
      } else if (
        selectedPlatform2 === "email" &&
        !/^[a-zA-Z0-9.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(
          platformInputref.current
        )
      ) {
        setnewformmediumValueErr(true);
        error.newformmediumValue = "Invalid email format";
        setvalidationErr(error);
      } else if (
        ["whatsApp", "skype", "telegram"].includes(selectedPlatform2)
      ) {
        if (platformInputref.current.trim() === "") {
          setnewformmediumValueErr(true);
          error.newformmediumValue = "Contact Medium is a required field";
          setvalidationErr(error);
        } else if (
          selectedPlatform2 === "whatsApp" &&
          platformInputref.current.length < 7
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = `Whatsapp number must be at least 7 digits`;
          setvalidationErr(error);
        } else if (
          selectedPlatform2 === "skype" &&
          platformInputref.current.length < 5
        ) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Skype ID / Number must be at least 5 characters`;
          setvalidationErr(error);
        } else if (platformInputref.current.length < 5) {
          setnewformmediumValueErr(true);
          error.newformmediumValue = ` Telegram ID / Number must be at least 5 characters`;
          setvalidationErr(error);
        } else {
          // setnewformuserNameErr(false);
          setnewformmediumValueErr(false);
        }
      } else {
        setnewformmediumValueErr(false);
      }

      if (formData.newformmessage.trim() === "") {
        // setnewformmediumValueErr(false);
        setnewformmessageErr(true);
        error.newformmessage = "Message is a required field";
        setvalidationErr(error);
      } else if (formData.newformmessage.length < 3) {
        setnewformmessageErr(true);
        error.newformmessage = "Message must contain at least 3 characters";
        setvalidationErr(error);
      } else if (formData.newformmessage.length > 250) {
        setnewformmessageErr(true);
        error.newformmessage = "Message can't exceed 250 characters";
        setvalidationErr(error);
      } else {
        setnewformmessageErr(false);
      }

      setvalidationErr(error);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePlatformInputChange = (e) => {
    const value = e.target.value;
    setPlatformInput(value);

    let error = {};
    let hasError = false;

    // Basic validation
    if (!value) {
      error.newformmediumValue = "This field is required.";
      hasError = true;
    } else if (
      selectedPlatform2 === "email" &&
      !/^[^\s@]+@[^\s@]+\.(com)$/i.test(value)
    ) {
      error.newformmediumValue = "Invalid email format.";
      hasError = true;
    } else if (selectedPlatform2 === "whatsApp" && value.length < 7) {
      error.newformmediumValue =
        "Invalid number, Must be at least 7 digits excluding country code";
      hasError = true;
    } else if (
      ["telegram", "skype"].includes(selectedPlatform2) &&
      value.length < 5
    ) {
      error.newformmediumValue = `${selectedPlatform2} ID must be at least 5 characters.`;
      hasError = true;
    }

    setvalidationErr(error);
    setnewformmediumValueErr(hasError);

    // if (value && value.length > 0) {
    //   setnewformmediumErr(false);
    //   setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
    // } else {
    //   setnewformmediumErr(true);
    //   setvalidationErr((prev) => ({
    //     ...prev,
    //     newformmedium: "Must enter the field",
    //   }));
    // }
    // // newValueref.current.newformmessage = "";
    // validate(newValueref.current);
    // if (
    //   selectedPlatform2 === "email" &&
    //   !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref.current)
    // ) {
    //   validate(newValueref.current);
    // }
  };

  // const handlePlatformInputChange = (e) => {
  //   let value = e.target.value;
  //   if (e.target.type === "number") {
  //     if (value !== "" && parseFloat(value) < 0) {
  //       return;
  //     }
  //   }
  //   if (e.target.value.startsWith(" ")) {
  //     e.preventDefault();
  //     value.trimStart();
  //   } else {
  //     setPlatformInput(value);
  //     if (value && value.length > 0) {
  //       setnewformmediumErr(false);
  //       setvalidationErr((prev) => ({ ...prev, newformmedium: "" }));
  //     } else {
  //       setnewformmediumErr(true);
  //       setvalidationErr((prev) => ({
  //         ...prev,
  //         newformmedium: "Must enter the field",
  //       }));
  //     }
  //     validate(newValueref.current);
  //     if (
  //       selectedPlatform2 === "email" &&
  //       !/^[^\s@]+@[^\s@]+\.(com)$/.test(platformInputref.current)
  //     ) {
  //       validate(newValueref.current);
  //     }
  //   }
  // };

  // const handleKeyPress = (e, maxLength, type) => {
  //   if (
  //     e.target.value.length >= maxLength &&
  //     ![
  //       "Backspace",
  //       "Delete",
  //       "Tab",
  //       "Escape",
  //       "Enter",
  //       "ArrowLeft",
  //       "ArrowRight",
  //     ].includes(e.key)
  //   ) {
  //     e.preventDefault();
  //     return;
  //   }

  //   if (type === "email") {
  //     const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
  //     if (
  //       !validEmailChars.test(e.key) &&
  //       ![
  //         "Backspace",
  //         "Delete",
  //         "Tab",
  //         "Escape",
  //         "Enter",
  //         "ArrowLeft",
  //         "ArrowRight",
  //       ].includes(e.key)
  //     ) {
  //       e.preventDefault();
  //     }
  //     return;
  //   }

  //   if (type === "number") {
  //     const cursorPosition = e.target.selectionStart;
  //     const value = e.target.value;

  //     if (e.key === " " && cursorPosition === 0) {
  //       e.preventDefault();
  //       return;
  //     }

  //     if (e.key === "e") {
  //       e.preventDefault();
  //       return;
  //     }

  //     if (
  //       !/[0-9 ]/.test(e.key) &&
  //       !(e.key === "+" && cursorPosition === 0) &&
  //       ![
  //         "Backspace",
  //         "Delete",
  //         "Tab",
  //         "Escape",
  //         "Enter",
  //         "ArrowLeft",
  //         "ArrowRight",
  //       ].includes(e.key)
  //     ) {
  //       e.preventDefault();
  //     }
  //     return;
  //   }

  //   if (type === "text") {
  //     const cursorPosition = e.target.selectionStart;
  //     const value = e.target.value;

  //     if (e.key === " " && cursorPosition === 0) {
  //       e.preventDefault();
  //       return;
  //     }
  //     if (
  //       value.length < maxLength ||
  //       [
  //         "Backspace",
  //         "Delete",
  //         "Tab",
  //         "Escape",
  //         "Enter",
  //         "ArrowLeft",
  //         "ArrowRight",
  //       ].includes(e.key)
  //     ) {
  //       return;
  //     }

  //     e.preventDefault();
  //   }
  // };

  const handleKeyPress = (e, maxLength, type) => {
    if (
      e.target.value.length >= maxLength &&
      ![
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
      ].includes(e.key)
    ) {
      e.preventDefault();
      return;
    }

    if (type === "email") {
      const validEmailChars = /^[a-zA-Z0-9@._-]+$/;
      if (
        !validEmailChars.test(e.key) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "number") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      // Prevent space at the start
      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }

      // Allow only digits, plus symbol at the start, spaces in the middle, and control keys
      if (
        !/[0-9 ]/.test(e.key) &&
        !(e.key === "+" && cursorPosition === 0) &&
        ![
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        e.preventDefault();
      }
      return;
    }

    if (type === "text") {
      const cursorPosition = e.target.selectionStart;
      const value = e.target.value;

      if (e.key === " " && cursorPosition === 0) {
        e.preventDefault();
        return;
      }
      if (
        value.length < maxLength ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
        ].includes(e.key)
      ) {
        return;
      }

      e.preventDefault();
    }
  };

  const handlePlatformSelect = (e, platform) => {
    e.preventDefault();
    setSelectedPlatform2(platform);
    setPlatformInput("");
  };

  // const handleNewFormChange = async (e) => {
  //   try {
  //     e.preventDefault();
  //     const { name, value } = e.target;
  //     if (e.target.value.startsWith(" ")) {
  //       e.preventDefault();
  //       setnewValue((prevState) => ({
  //         ...prevState,
  //         [name]: value.trimStart(),
  //       }));
  //       return;
  //     } else {
  //       let formData = { ...newValue, ...{ [name]: value } };
  //       setnewValue(formData);
  //       await validate(formData);

  //       if (selectedPlatform2 && !platformInputref.current) {
  //         setnewformmediumValueErr(true);
  //       } else {
  //         setnewformmediumValueErr(false);
  //       }
  //     }

  //   } catch (error) {
  //   }
  // };

  const handleNewFormChange = async (e) => {
    try {
      e.preventDefault();
      const { name, value } = e.target;

      // Update form state
      let formData = { ...newValue, [name]: value };
      setnewValue(formData);

      // Validate only `newformmessage`
      if (name === "newformmessage") {
        let error = { ...validationErr };

        if (!value.trim()) {
          error.newformmessage = "Message is a required field";
          setnewformmessageErr(true);
        } else if (value.length < 3) {
          error.newformmessage = "Message must contain at least 3 characters";
          setnewformmessageErr(true);
        } else if (value.length > 250) {
          error.newformmessage = "Message can't exceed 250 characters";
          setnewformmessageErr(true);
        } else {
          delete error.newformmessage; // Remove error if valid
          setnewformmessageErr(false);
        }

        setvalidationErr(error);
      }

      // e.preventDefault();
      // const { name, value } = e.target;
      // let formData = { ...newValue, ...{ [name]: value } };
      // setnewValue(formData);
      // await validate(formData);

      // if (selectedPlatform2 && !platformInputref.current) {
      //   setnewformmediumValueErr(true);
      // } else {
      //   setnewformmediumValueErr(false);
      // }

      // if (name === "newformmessage") {
      //   if (!value.trim()) {
      //     setnewformmessageErr(true);
      //   } else {
      //     setnewformmessageErr(false);
      //   }
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const [buttonLoader, setbuttonLoader] = useState(false);

  // const sendServiceContact = async (e) => {
  //   try {
  //     validate(newValueref.current);
  //     e.preventDefault();
  //     if (
  //       newValueref.current.newformuserName !== "" &&
  //       newformuserNameErrref.current === false &&
  //       newformmessageErrref.current === false &&
  //       newformmobileErrref.current === false &&
  //       newformmediumValueErrref.current == false &&
  //       newformmobilecodeErr === false &&
  //       newValueref.current.newformmessage != ""
  //     ) {
  //       newValueref.current.newformmedium = selectedPlatform2;
  //       newValueref.current.newformmediumValue = platformInputref.current;

  //       var obj = {
  //         apiUrl: httpService.sendServiceContactDetails,
  //         payload: newValueref.current,
  //       };
  //       var messageSent = await sendcontactpageContacts(obj);
  //       setbuttonLoader(false);
  //       newValueref.current.newformuserName = "";
  //       newValueref.current.newformmessage = "";
  //       newValueref.current.newformmobile = "";
  //       newValueref.current.newformmobilecode = "";
  //       setNewFormMobileValue("");
  //       setPlatformInput("");
  //       setNewFormNMobileCode("");
  //       setNewFormcountry();
  //       handleNewFormMobile("", "", "", "");
  //       if (messageSent.status == true) {
  //         toastAlert("success", messageSent.Message);
  //         window.location.reload();
  //       } else {
  //         toastAlert("error", messageSent.Message);
  //       }
  //     } else {
  //       validate(newValueref.current);
  //     }
  //   } catch (errr) {
  //   }
  // };

  const sendServiceContact = async (e) => {
    try {
      e.preventDefault();
      validate(newValueref.current);
      console.log(newValueref.current);
      console.log(
        newValueref.current.newformuserName,
        newformuserNameErrref.current,
        newformmessageErrref.current,
        newformmobileErrref.current,
        newformmediumValueErrref.current,
        newformmobilecodeErr,
        newValueref.current.newformmessage
      );

      if (
        newValueref.current.newformuserName !== "" &&
        newformuserNameErrref.current === false &&
        newformmessageErrref.current === false &&
        newformmobileErrref.current === false &&
        newformmediumValueErrref.current == false &&
        newformmobilecodeErr === false &&
        newValueref.current.newformmessage != ""
      ) {
        setbuttonLoader(true);

        newValueref.current.newformmedium = selectedPlatform2;
        newValueref.current.newformmediumValue = platformInputref.current;

        var obj = {
          apiUrl: httpService.sendServiceContactDetails,
          payload: newValueref.current,
        };
        var messageSent = await sendcontactpageContacts(obj);
        

        if (messageSent.status == true) {
          toastAlert("success", messageSent.Message);
          setbuttonLoader(false);
        } else {
          toastAlert("error", messageSent.Message);
          setbuttonLoader(false);
        }
        newValueref.current.newformuserName = "";
        newValueref.current.newformmessage = "";
        newValueref.current.newformmobile = "";
        newValueref.current.newformmobilecode = "";
        setNewFormMobileValue("");
        setPlatformInput("");
        setNewFormNMobileCode("");
        setNewFormcountry();
        handleNewFormMobile("", "", "", "");
      } else {
        validate(newValueref.current);

      }
    } catch (errr) {
      console.log("errr", errr);
       setbuttonLoader(false);
    }
  };

  const cancelpopup = () => {};

  return (
    <div>
      <div
        className={`${!isReach ? "landingReachOut" : "landingReachOutLeft"}`}
      >
        <div className="landingReachOut__links">
          <div className="landingReachOut__links--wrapper">
            <a href="https://wa.me/7904323274" target="_blank">
              <img src={WHATSAPP} alt="whatsapp" loading="lazy" />
            </a>
          </div>
          <div className="landingReachOut__links--wrapper">
            <a href="https://telegram.me/BeleafSoftTech" target="_blank">
              <img src={TELEGRAM} alt="telegram" loading="lazy" />
            </a>
          </div>
          <div className="landingReachOut__links--wrapper">
            <a href="mailto:business@beleaftechnologies.com" target="_blank">
              <img src={MAIL} alt="mail" loading="lazy" />
            </a>
          </div>
          <div className="landingReachOut__links--wrapper">
            <a href="tel:+91 80567 86622" target="_blank">
              <img src={PHONE} alt="phone" loading="lazy" />
            </a>
          </div>
        </div>
        <div className="vertical-text" onClick={handleReachClick}>
          {isReach ? (
            <span>
              <img
                src={ARROW}
                alt="arrow"
                className="reachOutArrow"
                loading="lazy"
              />
            </span>
          ) : (
            "Reach Out"
          )}
        </div>
      </div>

      <div className="landing__explore--section pt-0">
        {/* get in touch */}
        <div>
          <div className="pr-contact-wrap-outer">
            <div className="pr-contact-wrap primary__landing-content-container">
              <div className="pr-ct-details">
                <span>
                  <i className="fa-brands fa-whatsapp"></i>
                </span>
                <span>+91 79043 23274</span>
              </div>
              <div className="pr-ct-details">
                <span>
                  {/* <img
                    src={TELEGRAM}
                    alt="World's No.1 Blockchain Development Company"
                    loading="lazy"
                  /> */}
                  <i className="fa-regular fa-paper-plane"></i>
                </span>
                <span>@BeleafSoftTech</span>
              </div>
              <div className="pr-ct-details">
                <span>
                  <i className="fa-regular fa-envelope"></i>
                </span>
                <span>business@beleaftechnologies.com</span>
              </div>
              <div className="pr-ct-details">
                <span>
                  <i className="bi bi-telephone"></i>
                </span>
                <span>+91 80567 86622</span>
              </div>
            </div>
          </div>

          <article className="primary__landing-content-container ">
            <div className="primary-get-in-touch">
              <div className="row">
                <div className="col-lg-6">
                  <div className="landing__contact">
                    <div>
                      <h5 className="landing__contact-title">Get In Touch</h5>
                      <p className="landing__contact-subContent">
                        We're here to assist you. Contact us for tailored
                        solutions to elevate your business.
                      </p>
                    </div>
                    <div className="landing__contact--address">
                      {/* <div className="landing__contact--address-wrap contact-primary-opacity">
                        <img src={CONTACTIMGTWO} alt="temple" loading="lazy" />
                        <div className="landing__contact--address-info">
                          <h6>India - Thane</h6>
                          <p>
                            12, 4th floor Krishnasthal CHS, Mira Gaon Mira Road
                            East, Thane, Maharastra, <br /> Postal Code -
                            401107, India.
                          </p>
                        </div>
                      </div> */}

                      <div className="landing__contact--address-wrap contact-opacity">
                        <img src={CONTACTIMG} alt="temple" loading="lazy" />
                        <div className="landing__contact--address-info">
                          <h6>India - Madurai</h6>
                          <p>
                            5/24, Bharathiyar 7th street, S.S.Colony Madurai,
                            Tamil Nadu, <br /> Postal Code - 625 016, India.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="landing__contact--form landing_cnt_ov_hidden">
                    <form>
                      <h4 className="landing__contact--form-title">
                        Your Details
                      </h4>

                      <div className="mt-4">
                        <label htmlFor="form-name">Name</label> <br />
                        <input
                          type="text"
                          id="form-name"
                          placeholder="Enter your name"
                          className="landing__form-input margin-bottom-land"
                          name="newformuserName"
                          autoComplete="off"
                          value={newformuserName}
                          max="50"
                          maxLength="50"
                          // onChange={handleNewFormChange}
                          // onBlur={(e) => handleKeyPress(e, 50, "text")}
                          onChange={(e) => {
                            const value = e.target.value;
                            setnewValue((prev) => ({
                              ...prev,
                              newformuserName: value,
                            }));

                            if (value.trim() === "") {
                              setnewformuserNameErr(true);
                              setvalidationErr((prev) => ({
                                ...prev,
                                newformuserName: "Name is a required field",
                              }));
                            } else if (value.length < 3) {
                              setnewformuserNameErr(true);
                              setvalidationErr((prev) => ({
                                ...prev,
                                newformuserName:
                                  "Invalid username, Must be 3-50 characters",
                              }));
                            } else {
                              setnewformuserNameErr(false);
                              setvalidationErr((prev) => ({
                                ...prev,
                                newformuserName: "",
                              }));
                            }
                          }}
                          onKeyPress={(e) => handleKeyPress(e, 50, "text")}
                        />
                        {newformuserNameErrref.current &&
                        newformuserNameErrref.current === true ? (
                          <div className="text-danger font_error_newch">
                            {" "}
                            {validationErrref.current.newformuserName}{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="mt-4">
                        <label htmlFor="mobile">Mobile Number</label> <br />
                        <PhoneInput
                          country={"us"}
                          value={NewFormMobileValue}
                          inputProps={{
                            name: "phonenumber",
                            required: true,
                          }}
                          autoComplete="off"
                          className="form-phone landing__form-input margin-bottom-land"
                          onChange={(value, countryObj, e, formattedValue) =>
                            handleNewFormMobile(
                              value,
                              countryObj,
                              e,
                              formattedValue
                            )
                          }
                        />
                        {newformmobileErrref.current &&
                        newformmobileErrref.current === true ? (
                          <div className="text-danger font_error_newch">
                            {validationErrref.current.newformmobile}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="mt-4">
                        <label htmlFor="form-contact">Contact Medium</label>{" "}
                        <br />
                        <div className="form-contact-medium">
                          <button
                            type="button"
                            className="dropdown-toggle landing__form-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {selectedPlatform2 == "whatsApp" ? (
                              <i className="fa-brands fa-whatsapp"></i>
                            ) : selectedPlatform2 == "telegram" ? (
                              <i className="fa-brands fa-telegram"></i>
                            // ) : selectedPlatform2 == "skype" ? (
                            //   <i className="fa-brands fa-skype"></i>
                            ) : selectedPlatform2 == "email" ? (
                              <i
                                className="fa fa-envelope"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              ""
                            )}
                          </button>
                          <div className="dropdown-menu landing__form-drop-menu">
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) =>
                                handlePlatformSelect(e, "whatsApp")
                              }
                            >
                              <i className="fa-brands fa-whatsapp"></i>
                            </a>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) =>
                                handlePlatformSelect(e, "telegram")
                              }
                            >
                              <i className="fa-brands fa-telegram"></i>
                            </a>
                            {/* <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => handlePlatformSelect(e, "skype")}
                            >
                              <i className="fa-brands fa-skype"></i>
                            </a> */}
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={(e) => handlePlatformSelect(e, "email")}
                            >
                              <i
                                className="fa fa-envelope"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </div>

                          {selectedPlatform2 && (
                            <input
                              type={
                                selectedPlatform2 === "whatsApp"
                                  ? "number"
                                  : "text"
                              }
                              className="landing__contact-medium-input"
                              placeholder={`Enter your ${selectedPlatform2} ${
                                selectedPlatform2 == "email"
                                  ? "Address"
                                  : selectedPlatform2 === "whatsApp"
                                  ? "number"
                                  : "number / ID"
                              }`}
                              maxLength={
                                selectedPlatform2 === "email"
                                  ? 250
                                  : selectedPlatform2 === "whatsApp"
                                  ? 15
                                  : 32
                              }
                              value={platformInputref.current}
                              autoComplete="off"
                              onChange={handlePlatformInputChange}
                              onKeyDown={(e) =>
                                handleKeyPress(
                                  e,
                                  selectedPlatform2 === "email"
                                    ? 250
                                    : selectedPlatform2 === "whatsApp"
                                    ? 15
                                    : 32,
                                  selectedPlatform2 === "email"
                                    ? "email"
                                    : selectedPlatform2 === "whatsApp"
                                    ? "number"
                                    : "text"
                                )
                              }
                            />
                          )}
                        </div>
                        {newformmediumValueErrref.current &&
                        newformmediumValueErrref.current === true ? (
                          <span className="text-danger font_error_newch">
                            {validationErrref.current.newformmediumValue}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="mt-4">
                        <label htmlFor="message">
                          Tell Us About Your Project
                        </label>
                        <br />
                        <textarea
                          id="message"
                          placeholder="Message"
                          className="landing__form-input landing-textarea landing__form-input margin-bottom-land"
                          rows="5"
                          name="newformmessage"
                          value={newformmessage}
                          max="250"
                          maxLength="250"
                          autoComplete="off"
                          onChange={handleNewFormChange}
                          onKeyPress={(e) => handleKeyPress(e, 250, "text")}
                        ></textarea>

                        {newformmessageErrref.current == true ? (
                          <div className="text-danger font_error_newch">
                            {validationErrref.current.newformmessage}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="text-center mt-4">
                        {buttonLoader == true ? (
                          <button className="explore__card-btn" disabled>
                            loading....
                            <span className="mx-2 right-arr">
                              <i className="fa-solid fa-arrow-right"></i>
                            </span>
                          </button>
                        ) : (
                          <div className="d-flex align-items-center justify-content-center">
                            <button
                              className="explore__card-btn re-hero-btn nw-ct-btn"
                              onClick={sendServiceContact}
                            >
                              <div className="re-btn-txt">Submit</div>
                              <span className="mx-2 right-arr">
                                <i className="fa-solid fa-arrow-right"></i>
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    </form>
                    <div className="landing__contact-fade"></div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>

        {/* <article className="primary__landing-content-container ">
          <div className="">
            <div className="row">
              <div className="col-lg-6">
                <div className="landing__contact">
                  <div>
                    <h5>Get In Touch</h5>
                    <p className="landing__contact-subContent">
                      We're here to assist you. Contact us for tailored
                      solutions to elevate your business.
                    </p>
                  </div>
                  <div className="landing__contact--address">
                    <div className="landing__contact--address-wrap contact-primary-opacity">
                      <img src={CONTACTIMG} alt="temple" loading="lazy" />
                      <div className="landing__contact--address-info">
                        <h6>India - Madurai</h6>
                        <p>
                          5/24, Bharathiyar 7th street, S.S.Colony Madurai-625
                          016, Tamil Nadu, India.
                        </p>
                      </div>
                    </div>

                    <div className="landing__contact--address-wrap contact-opacity">
                      <img src={CONTACTIMGTWO} alt="temple" loading="lazy" />
                      <div className="landing__contact--address-info">
                        <h6>India - Thane</h6>
                        <p>
                          12, 4th floor Krishnasthal CHS, Mira Gaon Mira Road
                          East, Thane, Maharastra, <br /> Postal Code - 401107,
                          India.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="landing__contact--form">
                  <form>
                    <h4 className="landing__contact--form-title">
                      Your Details
                    </h4>
                    <div className="mt-4">
                      <label htmlFor="form-name">Name</label> <br />
                      <input
                        type="text"
                        id="form-name"
                        placeholder="Enter your name"
                        className="landing__form-input margin-bottom-land"
                        name="newformuserName"
                        autoComplete="off"
                        value={newformuserName}
                        max="50"
                        maxLength="50"
                        onChange={handleNewFormChange}
                        onBlur={(e) => handleKeyPress(e, 50, "text")}
                      />
                      {newformuserNameErr && newformuserNameErr === true ? (
                        <div className="text-danger mt-3">
                          {validationErr.newformuserName}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mt-4">
                      <label htmlFor="mobile">Mobile Number</label> <br />
                      <PhoneInput
                        country={"us"}
                        value={NewFormMobileValue}
                        inputProps={{
                          name: "phonenumber",
                          required: true,
                        }}
                        autoComplete="off"
                        className="form-phone landing__form-input margin-bottom-land"
                        onChange={(value, countryObj, e, formattedValue) =>
                          handleNewFormMobile(
                            value,
                            countryObj,
                            e,
                            formattedValue
                          )
                        }
                      />
                      {newformmobileErr && newformmobileErr === true ? (
                        <div className="text-danger mt-3">
                          {validationErr.newformmobile}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mt-4">
                      <label htmlFor="form-contact">Contact Medium</label>{" "}
                      <br />
                      <div className="form-contact-medium">
                        <button
                          type="button"
                          className="dropdown-toggle landing__form-dropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {selectedPlatform2 == "whatsApp" ? (
                            <i className="fa-brands fa-whatsapp"></i>
                          ) : selectedPlatform2 == "telegram" ? (
                            <i className="fa-brands fa-telegram"></i>
                          ) : selectedPlatform2 == "skype" ? (
                            <i className="fa-brands fa-skype"></i>
                          ) : selectedPlatform2 == "email" ? (
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            ""
                          )}
                        </button>
                        <div className="dropdown-menu landing__form-drop-menu">
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "whatsApp")}
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "telegram")}
                          >
                            <i className="fa-brands fa-telegram"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "skype")}
                          >
                            <i className="fa-brands fa-skype"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "email")}
                          >
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>

                        {selectedPlatform2 && (
                          <input
                            type="text"
                            className="landing__contact-medium-input"
                            placeholder={`Enter your ${selectedPlatform2} ${
                              selectedPlatform2 == "email"
                                ? "Address"
                                : selectedPlatform2 === "whatsApp"
                                ? "number"
                                : "number / ID"
                            }`}
                            maxLength={
                              selectedPlatform2 === "email"
                                ? 250
                                : selectedPlatform2 === "whatsApp"
                                ? 15
                                : 32
                            }
                            value={platformInput}
                            autoComplete="off"
                            onChange={handlePlatformInputChange}
                            onBlur={(e) =>
                              handleKeyPress(
                                e,
                                selectedPlatform2 === "email"
                                  ? 250
                                  : selectedPlatform2 === "whatsApp"
                                  ? 15
                                  : 32,
                                selectedPlatform2 === "email"
                                  ? "email"
                                  : selectedPlatform2 === "whatsApp"
                                  ? "number"
                                  : "text"
                              )
                            }
                          />
                        )}
                      </div>
                      {newformmediumValueErr &&
                      newformmediumValueErr === true ? (
                        <div className="text-danger mt-3">
                          {validationErr.newformmediumValue}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mt-4">
                      <label htmlFor="message">
                        Tell Us About Your Project
                      </label>{" "}
                      <br />
                      <textarea
                        id="message"
                        placeholder="Message"
                        className="landing__form-input landing-textarea landing__form-input margin-bottom-land"
                        rows="5"
                        name="newformmessage"
                        value={newformmessage}
                        autoComplete="off"
                        onChange={handleNewFormChange}
                        onBlur={(e) => handleKeyPress(e, 250, "text")}
                      ></textarea>
                      {newformmessageErr && newformmessageErr === true ? (
                        <div className="text-danger mt-3">
                          {validationErr.newformmessage}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="text-center mt-4">
                      {buttonLoader == true ? (
                        <button className="explore__card-btn" disabled>
                          loading....
                          <span className="mx-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      ) : (
                        <button
                          className="explore__card-btn"
                          onClick={sendServiceContact}
                        >
                          Submit
                          <span className="mx-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </article> */}
      </div>

      {/* footer */}
      <article id="landing-navigate-footer">
        <NewFooter />
      </article>

      {/* footer social links */}
      <div className="landing__footer-copyrights">
        <div className="primary__landing-content-container">
          <div className="landing__footer-copyrights-flex">
            <div className="landing__footer-privacy">
              <h6 className="landing__footer-copyrights-title">
                Privacy policy | Terms & Conditions
              </h6>
            </div>
            <div>
              <h6 className="landing__footer-copyrights-title">
                &copy; 2025 Beleaf Technologies All Rights Reserved
              </h6>
            </div>
            <div>
              <ul className="landing__footer-social-links">
                <li>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/beleaf-technologies-blf/"
                  >
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/beleaftechnologies/"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://telegram.me/BeleafSoftTech" target="_blank">
                    <img src={TELEGRAM} alt="telegram" loading="lazy" />
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:business@beleaftechnologies.com"
                    target="_blank"
                  >
                    <i className="fa-regular fa-envelope"></i>
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/7904323274" target="_blank">
                    <i className="fa-brands fa-whatsapp"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://pin.it/3bOarDn">
                    <i className="fa-brands fa-pinterest-p"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Old Pop Up */}

      {/* <div id="myModal" className="modal fade contact_model" role="dialog">
        <div className="modal-dialog modal-md">
          <div className="modal-content banner_ee_orjhe">
            <div className="modal-body">
              <button
                type="button"
                className="close contwcte"
                data-dismiss="modal"
                onClick={cancelpopup}
              >
                ×
              </button>
              <div className="row">
                <div className="col-lg-12 padid_a00">
                  <div className="CTA_card_pop">
                    <form>
                      
                      <div className="form-group row">
                        <div className="col-sm-12 mb-3">
                          <label>Name</label>
                          <input
                            type="text"
                            id="form-name"
                            placeholder="Enter your name"
                            className="form-control"
                            name="newformuserName"
                            autoComplete="off"
                            value={newformuserName}
                            max="50"
                            maxLength="50"
                            onChange={handleNewFormChange}
                            onBlur={(e) => handleKeyPress(e, 50, "text")}
                          />
                          {newformuserNameErr && newformuserNameErr === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErr.newformuserName}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="col-sm-12  pb-3">
                          <div className=" react-tel-input d-flex flex-column align-items-start">
                            <label>Mobile</label>

                            <PhoneInput
                              country={"us"}
                              value={NewFormMobileValue}
                              inputProps={{
                                name: "phonenumber",
                                required: true,
                              }}
                              autoComplete="off"
                              onChange={(
                                value,
                                countryObj,
                                e,
                                formattedValue
                              ) =>
                                handleNewFormMobile(
                                  value,
                                  countryObj,
                                  e,
                                  formattedValue
                                )
                              }
                            />

                            {newformmobileErr && newformmobileErr === true ? (
                              <span className="text-danger">
                                {" "}
                                {validationErr.newformmobile}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-sm-12 pb-3 contact-medium-label">
                          <label>Contact Medium</label>
                          <div className="border_sledct">
                            <button
                              type="button"
                              className="btn dropdown-toggle"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              {selectedPlatform2 == "whatsApp" ? (
                                <i className="fa-brands fa-whatsapp"></i>
                              ) : selectedPlatform2 == "telegram" ? (
                                <i className="fa-brands fa-telegram"></i>
                              ) : selectedPlatform2 == "skype" ? (
                                <i className="fa-brands fa-skype"></i>
                              ) : selectedPlatform2 == "email" ? (
                                <i
                                  className="fa fa-envelope"
                                  aria-hidden="true"
                                ></i>
                              ) : (
                                ""
                              )}
                            </button>
                            <div className="dropdown-menu">
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) =>
                                  handlePlatformSelect(e, "whatsApp")
                                }
                              >
                                <i className="fa-brands fa-whatsapp"></i>
                              </a>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) =>
                                  handlePlatformSelect(e, "telegram")
                                }
                              >
                                <i className="fa-brands fa-telegram"></i>
                              </a>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) =>
                                  handlePlatformSelect(e, "skype")
                                }
                              >
                                <i className="fa-brands fa-skype"></i>
                              </a>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) =>
                                  handlePlatformSelect(e, "email")
                                }
                              >
                                <i
                                  className="fa fa-envelope"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>

                            {selectedPlatform2 && (
                              <input
                                type="text"
                                className="form-control"
                                placeholder={`Enter your ${selectedPlatform2} ${
                                  selectedPlatform2 == "email"
                                    ? "Address"
                                    : selectedPlatform2 === "whatsApp"
                                    ? "number"
                                    : "number / ID"
                                }`}
                                maxLength={
                                  selectedPlatform2 === "email"
                                    ? 250
                                    : selectedPlatform2 === "whatsApp"
                                    ? 15
                                    : 32
                                }
                                value={platformInputref.current}
                                autoComplete="off"
                                onChange={handlePlatformInputChange}
                                onBlur={(e) =>
                                  handleKeyPress(
                                    e,
                                    selectedPlatform2 === "email"
                                      ? 250
                                      : selectedPlatform2 === "whatsApp"
                                      ? 15
                                      : 32,
                                    selectedPlatform2 === "email"
                                      ? "email"
                                      : selectedPlatform2 === "whatsApp"
                                      ? "number"
                                      : "text"
                                  )
                                }
                              />
                            )}
                          </div>
                          <span className="text-danger">
                            {validationErr.newformmediumValue}
                          </span>
                        </div>
                        <div className="col-sm-12  pt-0 pb-0 contact-medium-label">
                          <label>Tell us about your project</label>

                          <textarea
                            id="message"
                            placeholder="Message"
                            className="form-control"
                            rows="5"
                            name="newformmessage"
                            value={newformmessage}
                            max="250"
                            maxLength="250"
                            autoComplete="off"
                            onChange={handleNewFormChange}
                            onBlur={(e) => handleKeyPress(e, 250, "text")}
                          ></textarea>
                          {newformmessageErr && newformmessageErr === true ? (
                            <span className="text-danger">
                              {" "}
                              {validationErr.newformmessage}{" "}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12 pr-0">
                        <div className="banner_text_section p-0">
                          <button
                            className="MuiButtonBase-root MuiButton-root MuiButton-text m-0"
                            tabindex="0"
                            type="button"
                            onClick={sendServiceContact}
                          >
                            Send Message
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* New Pop Up */}
      <div id="myModal" className="modal fade contact_model" role="dialog">
        <div className="modal-dialog modal-md ">
          <div className="modal-content service-modal-content">
            <div>
              <div className="landing__contact--form hero-modal-contact">
                <form className="p-0">
                  <h4 className="landing__contact--form-title contact-us-title d-flex justify-content-between align-items-center">
                    Your Details
                    <button
                      type="button"
                      className="service-modal-btn"
                      data-dismiss="modal"
                      onClick={cancelpopup}
                    >
                      ×
                    </button>
                  </h4>
                  <div className="mt-4">
                    <label htmlFor="form-name" className="contact-us-label">
                      Name
                    </label>{" "}
                    <br />
                    <input
                      type="text"
                      id="form-name"
                      placeholder="Enter your name"
                      className="landing__form-input margin-bottom-land contact-us-input"
                      name="newformuserName"
                      autoComplete="off"
                      value={newformuserName}
                      max="50"
                      maxLength="50"
                      onChange={handleNewFormChange}
                      onBlur={(e) => handleKeyPress(e, 50, "text")}
                    />
                    {newformuserNameErrref.current &&
                    newformuserNameErrref.current === true ? (
                      <div className="text-danger font_error_newch">
                        {" "}
                        {validationErrref.current.newformuserName}{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-4">
                    <label htmlFor="mobile" className="contact-us-label">
                      Mobile Number
                    </label>{" "}
                    <br />
                    <PhoneInput
                      country={"us"}
                      value={NewFormMobileValue}
                      inputProps={{
                        name: "phonenumber",
                        required: true,
                      }}
                      autoComplete="off"
                      className="form-phone landing__form-input margin-bottom-land contact-us-input contact-us-phone"
                      onChange={(value, countryObj, e, formattedValue) =>
                        handleNewFormMobile(
                          value,
                          countryObj,
                          e,
                          formattedValue
                        )
                      }
                    />
                    {newformmobileErrref.current &&
                    newformmobileErrref.current === true ? (
                      <div className="text-danger font_error_newch">
                        {validationErrref.current.newformmobile}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-4">
                    <label htmlFor="form-contact" className="contact-us-label">
                      Contact Medium
                    </label>{" "}
                    <br />
                    <div className="form-contact-medium contact-us-input">
                      <button
                        type="button"
                        className="dropdown-toggle landing__form-dropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        {selectedPlatform2 == "whatsApp" ? (
                          <i className="fa-brands fa-whatsapp"></i>
                        ) : selectedPlatform2 == "telegram" ? (
                          <i className="fa-brands fa-telegram"></i>
                        // ) : selectedPlatform2 == "skype" ? (
                        //   <i className="fa-brands fa-skype"></i>
                        ) : selectedPlatform2 == "email" ? (
                          <i className="fa fa-envelope" aria-hidden="true"></i>
                        ) : (
                          ""
                        )}
                      </button>
                      <div className="dropdown-menu landing__form-drop-menu">
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "whatsApp")}
                        >
                          <i className="fa-brands fa-whatsapp"></i>
                        </a>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "telegram")}
                        >
                          <i className="fa-brands fa-telegram"></i>
                        </a>
                        {/* <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "skype")}
                        >
                          <i className="fa-brands fa-skype"></i>
                        </a> */}
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={(e) => handlePlatformSelect(e, "email")}
                        >
                          <i className="fa fa-envelope" aria-hidden="true"></i>
                        </a>
                      </div>

                      {selectedPlatform2 && (
                        <input
                          type={
                            selectedPlatform2 === "whatsApp" ? "number" : "text"
                          }
                          className="landing__contact-medium-input"
                          placeholder={`Enter your ${selectedPlatform2} ${
                            selectedPlatform2 == "email"
                              ? "Address"
                              : selectedPlatform2 === "whatsApp"
                              ? "number"
                              : "number / ID"
                          }`}
                          maxLength={
                            selectedPlatform2 === "email"
                              ? 250
                              : selectedPlatform2 === "whatsApp"
                              ? 15
                              : 32
                          }
                          value={platformInputref.current}
                          autoComplete="off"
                          onChange={handlePlatformInputChange}
                          onBlur={(e) =>
                            handleKeyPress(
                              e,
                              selectedPlatform2 === "email"
                                ? 250
                                : selectedPlatform2 === "whatsApp"
                                ? 15
                                : 32,
                              selectedPlatform2 === "email"
                                ? "email"
                                : selectedPlatform2 === "whatsApp"
                                ? "number"
                                : "text"
                            )
                          }
                        />
                      )}
                    </div>
                    {newformmediumValueErrref.current &&
                    newformmediumValueErrref.current === true ? (
                      <span className="text-danger font_error_newch">
                        {validationErrref.current.newformmediumValue}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="mt-4">
                    <label htmlFor="message" className="contact-us-label">
                      Tell Us About Your Project
                    </label>
                    <br />
                    <textarea
                      id="message"
                      placeholder="Message"
                      className="landing__form-input landing-textarea landing__form-input margin-bottom-land contact-us-input"
                      rows="5"
                      name="newformmessage"
                      value={newformmessage}
                      max="250"
                      maxLength="250"
                      autoComplete="off"
                      onChange={handleNewFormChange}
                      onKeyPress={(e) => handleKeyPress(e, 250, "text")}
                    ></textarea>

                    {newformmessageErrref.current == true ? (
                      <div className="text-danger font_error_newch">
                        {validationErrref.current.newformmessage}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="text-center mt-4">
                    {buttonLoader == true ? (
                      <button className="primary-landing-main-btn" disabled>
                        loading....
                        <span className="ml-2 right-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </button>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center">
                        <button
                          className="primary-landing-main-btn re-hero-btn nw-ct-btn"
                          onClick={sendServiceContact}
                        >
                          <div className="re-btn-txt">Submit</div>
                          <span className="ml-2 right-arr">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                  {/* <div className="form-group row">
                    <div className="col-sm-12 mb-3">
                      <label>Name</label>
                      <input
                        type="text"
                        id="form-name"
                        placeholder="Enter your name"
                        className="form-control"
                        name="newformuserName"
                        autoComplete="off"
                        value={newformuserName}
                        max="50"
                        maxLength="50"
                        onChange={handleNewFormChange}
                        onBlur={(e) => handleKeyPress(e, 50, "text")}
                      />
                      {newformuserNameErr && newformuserNameErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErr.newformuserName}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="col-sm-12  pb-3">
                      <div className=" react-tel-input d-flex flex-column align-items-start">
                        <label>Mobile</label>

                        <PhoneInput
                          country={"us"}
                          value={NewFormMobileValue}
                          inputProps={{
                            name: "phonenumber",
                            required: true,
                          }}
                          autoComplete="off"
                          onChange={(value, countryObj, e, formattedValue) =>
                            handleNewFormMobile(
                              value,
                              countryObj,
                              e,
                              formattedValue
                            )
                          }
                        />

                        {newformmobileErr && newformmobileErr === true ? (
                          <span className="text-danger">
                            {" "}
                            {validationErr.newformmobile}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-sm-12 pb-3 contact-medium-label">
                      <label>Contact Medium</label>
                      <div className="border_sledct">
                        <button
                          type="button"
                          className="btn dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {selectedPlatform2 == "whatsApp" ? (
                            <i className="fa-brands fa-whatsapp"></i>
                          ) : selectedPlatform2 == "telegram" ? (
                            <i className="fa-brands fa-telegram"></i>
                          ) : selectedPlatform2 == "skype" ? (
                            <i className="fa-brands fa-skype"></i>
                          ) : selectedPlatform2 == "email" ? (
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          ) : (
                            ""
                          )}
                        </button>
                        <div className="dropdown-menu">
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "whatsApp")}
                          >
                            <i className="fa-brands fa-whatsapp"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "telegram")}
                          >
                            <i className="fa-brands fa-telegram"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "skype")}
                          >
                            <i className="fa-brands fa-skype"></i>
                          </a>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={(e) => handlePlatformSelect(e, "email")}
                          >
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>

                        {selectedPlatform2 && (
                          <input
                            type="text"
                            className="form-control"
                            placeholder={`Enter your ${selectedPlatform2} ${
                              selectedPlatform2 == "email"
                                ? "Address"
                                : selectedPlatform2 === "whatsApp"
                                ? "number"
                                : "number / ID"
                            }`}
                            maxLength={
                              selectedPlatform2 === "email"
                                ? 250
                                : selectedPlatform2 === "whatsApp"
                                ? 15
                                : 32
                            }
                            value={platformInputref.current}
                            autoComplete="off"
                            onChange={handlePlatformInputChange}
                            onBlur={(e) =>
                              handleKeyPress(
                                e,
                                selectedPlatform2 === "email"
                                  ? 250
                                  : selectedPlatform2 === "whatsApp"
                                  ? 15
                                  : 32,
                                selectedPlatform2 === "email"
                                  ? "email"
                                  : selectedPlatform2 === "whatsApp"
                                  ? "number"
                                  : "text"
                              )
                            }
                          />
                        )}
                      </div>
                      <span className="text-danger">
                        {validationErr.newformmediumValue}
                      </span>
                    </div>
                    <div className="col-sm-12  pt-0 pb-0 contact-medium-label">
                      <label>Tell us about your project</label>

                      <textarea
                        id="message"
                        placeholder="Message"
                        className="form-control"
                        rows="5"
                        name="newformmessage"
                        value={newformmessage}
                        max="250"
                        maxLength="250"
                        autoComplete="off"
                        onChange={handleNewFormChange}
                        onBlur={(e) => handleKeyPress(e, 250, "text")}
                      ></textarea>
                      {newformmessageErr && newformmessageErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {validationErr.newformmessage}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12 pr-0">
                    <div className="banner_text_section p-0">
                      <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text m-0"
                        tabindex="0"
                        type="button"
                        onClick={sendServiceContact}
                      >
                        Send Message
                      </button>
                    </div>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceFooter;
